export default __webpack_public_path__ + "static/media/image-ph-study-main-1-n-m.9a8d6ba3.png";